// extracted by mini-css-extract-plugin
export default {"actionsCell":"J7mEpMdF2KfjfCrtWxjW"};